import { Autocomplete, Chip, TextField } from "@mui/material";
import { Field, useField } from "formik";
import { isString } from "lodash-es";

const options: string[] = [];

export interface OptionsFieldProps {
  name: string;
  inputLabel: string;
  inputPlaceholder?: string;
  required?: boolean;
  autoFocus?: boolean;
  disabled?: boolean;
  noOptionsText?: string;
  helperText?: string;
}

export const OptionsField = ({
  name,
  disabled,
  required,
  inputLabel,
  inputPlaceholder,
  autoFocus,
  noOptionsText,
  helperText,
}: OptionsFieldProps) => {
  const [, { value, touched, error }, { setValue, setTouched }] =
    useField<string[]>(name);

  return (
    <Autocomplete
      value={value}
      freeSolo
      multiple
      fullWidth
      openOnFocus
      clearOnBlur
      autoHighlight
      handleHomeEndKeys
      selectOnFocus={true}
      autoFocus={autoFocus}
      noOptionsText={noOptionsText}
      options={options}
      disabled={disabled}
      renderInput={params => (
        <TextField
          {...params}
          name={name}
          label={inputLabel}
          placeholder={inputPlaceholder}
          disabled={disabled}
          required={required}
          error={touched && Boolean(error)}
          helperText={touched && isString(error) ? error : helperText}
        />
      )}
      renderValue={(value: string[], getTagProps: any) =>
        value.map((value, index) => {
          const { onDelete, ...tagProps } = getTagProps({ index });
          return (
            <Chip
              key={`${index}-${value}`}
              variant="outlined"
              size="small"
              label={value}
              onDelete={onDelete}
              {...tagProps}
            />
          );
        })
      }
      onChange={async (e: any, newValue: string[]) => {
        await setValue(newValue.map(v => v.trim()).filter(Boolean));
        await setTouched(true);
      }}
      disableCloseOnSelect
      disableClearable
    />
  );
};
